module.exports = __webpack_public_path__ + "static/media/de.805bce7f.svg";